import {isSafari} from '@/utils/index'

export default {
    data() {
      return {
        isSafari
      }
    },
    mounted() {
      if (this.isSafari) {
          // 去除safari浏览器导航栏的高度
          this.$root.$el.style="height:calc(100vh - 75px);overflow:hidden";
      }
    },
  };